import { get } from 'lodash';
import { paddingToString } from './css-utils';
export const getRegionSpacing = (css, type, fallbackClass = undefined) => {
    const globalRegion = css['so-global-region'];
    const region = css[fallbackClass || `so-global-region-${type}`] || {};
    const margin = {
        top: parseInt(region.marginTop || globalRegion.marginTop, 10) || 0,
        right: parseInt(region.marginRight || globalRegion.marginRight, 10) || 0,
        bottom: parseInt(region.marginBottom || globalRegion.marginBottom, 10) || 0,
        left: parseInt(region.marginLeft || globalRegion.marginLeft, 10) || 0,
    };
    const padding = {
        top: parseInt(region.paddingTop || globalRegion.paddingTop, 10) || 0,
        right: parseInt(region.paddingRight || globalRegion.paddingRight, 10) || 0,
        bottom: parseInt(region.paddingBottom || globalRegion.paddingBottom, 10) || 0,
        left: parseInt(region.paddingLeft || globalRegion.paddingLeft, 10) || 0,
    };
    return {
        padding,
        margin,
    };
};
export const getSectionPadding = (css, type) => paddingToString(getSectionPaddingAsObject(css, type));
export const getSectionPaddingAsObject = (css, type, userOverrides = undefined) => {
    const globalRegion = css['so-global-region'];
    const region = css[`so-global-region-${type}`] || {};
    const bodyPaddingLeft = parseInt(get(css, 'so-global-body.paddingLeft'), 10) || 0;
    const bodyPaddingRight = parseInt(get(css, 'so-global-body.paddingRight'), 10) || 0;
    const padding = {
        top: parseInt(userOverrides?.paddingTop ||
            region.paddingTop ||
            globalRegion.paddingTop, 10) || 0,
        right: parseInt(userOverrides?.paddingRight ||
            region.paddingRight ||
            globalRegion.paddingRight, 10) || 0,
        bottom: parseInt(userOverrides?.paddingBottom ||
            region.paddingBottom ||
            globalRegion.paddingBottom, 10) || 0,
        left: parseInt(userOverrides?.paddingLeft ||
            region.paddingLeft ||
            globalRegion.paddingLeft, 10) || 0,
    };
    padding.left += bodyPaddingLeft;
    padding.right += bodyPaddingRight;
    return padding;
};
export const getSectionMarginAsObject = (css, type) => {
    const globalRegion = css['so-global-region'];
    const region = css[`so-global-region-${type}`] || {};
    return {
        top: parseInt(region.marginTop || globalRegion.marginTop, 10) || 0,
        right: parseInt(region.marginRight || globalRegion.marginRight, 10) || 0,
        bottom: parseInt(region.marginBottom || globalRegion.marginBottom, 10) || 0,
        left: parseInt(region.marginLeft || globalRegion.marginLeft, 10) || 0,
    };
};
//# sourceMappingURL=get-section-padding.js.map